(function () {
  const headingPattern = /\b(details|specifications|dimensions)$/i;
  const specificationPattern = /^(material|materials|stone|gemstone|stone\s+diameter|pendant\s+size|pentagram\s+size|size|dimensions|diameter|width|height|weight|pendant\s+weight|necklace\s+length|length|(?:black\s+cotton\s+)?cord|chain|finish|quantity|set\s+includes|craft)(?:\s*:|\s+\()/i;

  function technicalLines(paragraph) {
    return paragraph.innerHTML
      .split(/<br\s*\/?\s*>/i)
      .map((line) => {
        const holder = document.createElement('div');
        holder.innerHTML = line;
        return holder.textContent.replace(/^\s*[\-*•]\s*/, '').trim();
      })
      .filter((line) => specificationPattern.test(line));
  }

  function buildCard(lines) {
    const card = document.createElement('div');
    card.className = 'product-specifications';

    const heading = document.createElement('h2');
    heading.textContent = 'Technical specifications';
    card.appendChild(heading);

    const list = document.createElement('ul');
    lines.forEach((line) => {
      const item = document.createElement('li');
      const separator = line.indexOf(':');

      if (separator > -1) {
        const label = document.createElement('strong');
        label.textContent = `${line.slice(0, separator)}:`;
        item.append(label, document.createTextNode(line.slice(separator + 1)));
      } else {
        item.textContent = line;
      }

      list.appendChild(item);
    });

    card.appendChild(list);
    return card;
  }

  document.querySelectorAll('.product-tabs__tab-item-content.rte').forEach((description) => {
    if (description.dataset.specificationsEnhanced === 'true') return;
    description.dataset.specificationsEnhanced = 'true';

    if (description.querySelector('.product-specifications')) return;

    const heading = Array.from(description.querySelectorAll(':scope > h2, :scope > h3'))
      .find((candidate) => headingPattern.test(candidate.textContent.trim()));

    if (heading) {
      const card = document.createElement('div');
      card.className = 'product-specifications';
      description.insertBefore(card, heading);
      card.appendChild(heading);
      heading.textContent = 'Technical specifications';

      while (card.nextSibling && !/^H[23]$/.test(card.nextSibling.nodeName)) {
        card.appendChild(card.nextSibling);
      }

      return;
    }

    const paragraph = Array.from(description.querySelectorAll(':scope > p'))
      .find((candidate) => technicalLines(candidate).length >= 2);

    if (!paragraph) return;

    const lines = technicalLines(paragraph);
    const card = buildCard(lines);
    description.insertBefore(card, paragraph.nextSibling);

    const remainingLines = paragraph.innerHTML
      .split(/<br\s*\/?\s*>/i)
      .filter((line) => {
        const holder = document.createElement('div');
        holder.innerHTML = line;
        const text = holder.textContent.replace(/^\s*[\-*•]\s*/, '').trim();
        return text && !specificationPattern.test(text);
      });

    if (remainingLines.length) {
      paragraph.innerHTML = remainingLines.join('<br>');
    } else {
      paragraph.remove();
    }
  });
})();
